import React from "react";
import FadeInAnimation from "../Common/FadeInAnimation";
import { BiTrophy, BiGridAlt, BiCalendar } from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';

const StartseiteStats = () => {
    const { t } = useTranslations();

    return (
        <section className="ptb-80" style={{
            background: 'linear-gradient(135deg, #080a3c 0%, #1a1c4a 50%, #2d3748 100%)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Dekorative Elemente */}
            <div style={{
                position: 'absolute',
                top: '20%',
                left: '10%',
                width: '200px',
                height: '200px',
                background: 'linear-gradient(135deg, rgba(89, 189, 101, 0.1), rgba(76, 175, 80, 0.1))',
                borderRadius: '50%',
                filter: 'blur(40px)',
                zIndex: '1'
            }}></div>

            <div style={{
                position: 'absolute',
                bottom: '15%',
                right: '15%',
                width: '150px',
                height: '150px',
                background: 'linear-gradient(135deg, rgba(89, 189, 101, 0.08), rgba(76, 175, 80, 0.08))',
                borderRadius: '50%',
                filter: 'blur(30px)',
                zIndex: '1'
            }}></div>

            <div className="container" style={{ position: 'relative', zIndex: '2' }}>
                <FadeInAnimation direction="up" delay={100}>
                    <div className="text-center mb-5">
                        <h2 style={{
                            fontSize: '2.8rem',
                            fontWeight: '700',
                            color: 'white',
                            marginBottom: '20px',
                            lineHeight: '1.2',
                            marginTop: '100px'
                        }}>
                            {t('startseite_stats_title')}
                        </h2>
                        <p style={{
                            fontSize: '1.1rem',
                            color: 'rgba(255, 255, 255, 0.8)',
                            lineHeight: '1.7',
                            maxWidth: '700px',
                            margin: '0 auto'
                        }}>
                            {t('startseite_stats_description')}
                        </p>
                    </div>
                </FadeInAnimation>

                <FadeInAnimation direction="up" delay={200}>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div style={{
                                textAlign: 'center',
                                padding: '30px 20px',
                                position: 'relative'
                            }}>
                                <div style={{
                                    background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto 25px',
                                    boxShadow: '0 15px 35px rgba(89, 189, 101, 0.4)',
                                    position: 'relative'
                                }}>
                                    <BiTrophy style={{ fontSize: '36px', color: 'white' }} />
                                    <div style={{
                                        position: 'absolute',
                                        top: '-5px',
                                        right: '-5px',
                                        width: '25px',
                                        height: '25px',
                                        background: 'rgba(255, 255, 255, 0.9)',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        color: '#59bd65'
                                    }}>
                                        +
                                    </div>
                                </div>
                                <div style={{
                                    fontSize: '3.5rem',
                                    fontWeight: '800',
                                    color: '#59bd65',
                                    marginBottom: '10px',
                                    lineHeight: '1'
                                }}>
                                    100+
                                </div>
                                <h3 style={{
                                    color: 'white',
                                    fontSize: '1.2rem',
                                    fontWeight: '600',
                                    marginBottom: '10px'
                                }}>
                                    {t('startseite_stats_erfolgreiche_projekte')}
                                </h3>
                                <p style={{
                                    color: 'rgba(255, 255, 255, 0.7)',
                                    fontSize: '0.95rem',
                                    margin: '0'
                                }}>
                                    {t('startseite_stats_erfolgreiche_projekte_description')}
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 mb-4">
                            <div style={{
                                textAlign: 'center',
                                padding: '30px 20px',
                                position: 'relative'
                            }}>
                                <div style={{
                                    background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto 25px',
                                    boxShadow: '0 15px 35px rgba(89, 189, 101, 0.4)',
                                    position: 'relative'
                                }}>
                                    <BiCalendar style={{ fontSize: '36px', color: 'white' }} />
                                    <div style={{
                                        position: 'absolute',
                                        top: '-5px',
                                        right: '-5px',
                                        width: '25px',
                                        height: '25px',
                                        background: 'rgba(255, 255, 255, 0.9)',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        color: '#59bd65'
                                    }}>
                                        +
                                    </div>
                                </div>
                                <div style={{
                                    fontSize: '3.5rem',
                                    fontWeight: '800',
                                    color: '#59bd65',
                                    marginBottom: '10px',
                                    lineHeight: '1'
                                }}>
                                    {t('startseite_stats_erfahrung_value')}
                                </div>
                                <h3 style={{
                                    color: 'white',
                                    fontSize: '1.2rem',
                                    fontWeight: '600',
                                    marginBottom: '10px'
                                }}>
                                    {t('startseite_stats_erfahrung')}
                                </h3>
                                <p style={{
                                    color: 'rgba(255, 255, 255, 0.7)',
                                    fontSize: '0.95rem',
                                    margin: '0'
                                }}>
                                    {t('startseite_stats_erfahrung_description')}
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 mb-4">
                            <div style={{
                                textAlign: 'center',
                                padding: '30px 20px',
                                position: 'relative'
                            }}>
                                <div style={{
                                    background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto 25px',
                                    boxShadow: '0 15px 35px rgba(89, 189, 101, 0.4)',
                                    position: 'relative'
                                }}>
                                    <BiGridAlt style={{ fontSize: '36px', color: 'white' }} />
                                    <div style={{
                                        position: 'absolute',
                                        top: '-5px',
                                        right: '-5px',
                                        width: '25px',
                                        height: '25px',
                                        background: 'rgba(255, 255, 255, 0.9)',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        color: '#59bd65'
                                    }}>
                                        +
                                    </div>
                                </div>
                                <div style={{
                                    fontSize: '3.5rem',
                                    fontWeight: '800',
                                    color: '#59bd65',
                                    marginBottom: '10px',
                                    lineHeight: '1'
                                }}>
                                    {t('startseite_stats_leistungsbereiche_value')}
                                </div>
                                <h3 style={{
                                    color: 'white',
                                    fontSize: '1.2rem',
                                    fontWeight: '600',
                                    marginBottom: '10px'
                                }}>
                                    {t('startseite_stats_leistungsbereiche')}
                                </h3>
                                <p style={{
                                    color: 'rgba(255, 255, 255, 0.7)',
                                    fontSize: '0.95rem',
                                    margin: '0'
                                }}>
                                    {t('startseite_stats_leistungsbereiche_description')}
                                </p>
                            </div>
                        </div>


                    </div>
                </FadeInAnimation>
            </div>

            <style jsx>{`
        @media (max-width: 768px) {
          h2 {
            font-size: 2.2rem !important;
          }
          
          .col-lg-3 {
            margin-bottom: 30px !important;
          }
          
          div[style*="font-size: 3.5rem"] {
            font-size: 2.8rem !important;
          }
        }
      `}</style>
        </section>
    );
};

export default StartseiteStats; 